export default __webpack_public_path__ + "static/media/TF.1639d924.svg";